import { billing } from '@/api/index'

export function getTydSort (data) {
  return billing.request({
    method: 'post',
    url: '/GetTydSort',
    data
  })
}

export function getClassName (data) {
  return billing.request({
    method: 'post',
    url: '/GetClassName',
    data
  })
}

export function saveSmsModel (data) {
  return billing.request({
    method: 'post',
    url: '/SaveSmsModel',
    data
  })
}

export function getSmsModelData (data) {
  return billing.request({
    method: 'post',
    url: '/GetSmsModelData',
    data,
    // 设置识别为formData的数据
    iSFromData: true
  })
}
export function getSmsManDataNew (data) {
  return billing.request({
    method: 'post',
    url: '/GetSmsManData_new',
    data,
    iSFromData: true
  })
}

export function uploadExecl (data) {
  return billing.request({
    method: 'post',
    url: '/UploadExecl',
    data
    // iSFromData: true
  })
}

export function GetShipperAgain (data) {
  return billing.request({
    method: 'post',
    url: '/GetShipperAgain',
    data
    // iSFromData: true
  })
}
